
import React from "react";
import useSEO from "@/hooks/useSEO";
import { STATIC_ROUTE_META } from "@/utils/routeMetadata";

const HomepageSchema = () => {
  useSEO(STATIC_ROUTE_META["/"]);

  return null;
};

export default HomepageSchema;
